import { formatRecoveryCode } from "@bt/domain";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "@/components/ui/dialog";

/**
 * The desktop app's recovery code (ADR 0013), shown once: when users are switched on, and after
 * it was used for a forgotten PIN, which replaces it.
 */
export function RecoveryCodeDialog({ code, onDone }: { code: string | null; onDone: () => void }) {
  const { t } = useTranslation();
  return (
    <Dialog open={code !== null} onOpenChange={(open) => !open && onDone()}>
      <DialogContent>
        <DialogHeader title={t("users.recoveryTitle")} description={t("users.recoveryBody")} />
        <DialogBody>
          <p
            className="rounded-lg bg-muted px-4 py-3 text-center font-mono text-xl font-semibold tracking-widest select-all"
            data-testid="recovery-code"
          >
            {code ? formatRecoveryCode(code) : null}
          </p>
        </DialogBody>
        <DialogFooter>
          <Button onClick={onDone}>{t("users.recoveryDone")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
